import { render, staticRenderFns } from "./taskAlertList.vue?vue&type=template&id=c803e40a&"
import script from "./taskAlertList.vue?vue&type=script&lang=js&"
export * from "./taskAlertList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports